import { useState } from "react";
import { RadioGroupInput } from "../atoms";
import { Box, Paper, Typography, Divider, FormControl, FormLabel } from "@mui/material";
import { PCA_DATA_SHARING_PRIVACY_POLICY } from "@/utils/Constants";

const CONSENT_KEY = "pcaDataSharing";
type true_or_false_str = "true" | "false";
type Consent = true_or_false_str | undefined;

export const PCADataSharingConsent: React.FC = () => {
  const [consent, mutateConsent] = useState<Consent>(getStoredValue);

  return (
    <Paper elevation={0} className="pca-data-sharing-container">
      <Typography variant="subtitle2" className="consent-para">
        I consent to Settld sharing the information I provide in this notification, including my
        personal data with our affiliate company, Phillips & Cohen Associates (UK) Ltd., to be used
        for their own commercial purposes, including contacting me in connection with debts owed by
        the deceased. I understand if I consent, Phillips & Cohen Associates (UK) Ltd., will process
        my information subject to their privacy policy.
      </Typography>

      <Divider className="divider" />

      <FormControl component="fieldset" fullWidth>
        <FormLabel component="legend" className="label">
          Data sharing consent
        </FormLabel>

        <Box>
          <RadioGroupInput
            value={consent}
            onValueChange={(value: string) => {
              storeValue(value as true_or_false_str);
              mutateConsent(value as Consent);
            }}
            error={undefined}
            disabled={false}
            fields={fields()}
          />
        </Box>
      </FormControl>
    </Paper>
  );
};
function fields(): ReadonlyArray<{
  label?: React.ReactNode | string;
  value?: string;
  info?: string;
}> {
  return [
    {
      value: "true",
      label: (
        <>
          I understand if I consent, Phillips & Cohen Associates (UK) Ltd., will process my
          information subject to their{" "}
          <a href={PCA_DATA_SHARING_PRIVACY_POLICY} target="_blank">
            privacy policy
          </a>
          .
        </>
      ),
    },
    { value: "false", label: "I do not consent." },
  ];
}
function getStoredValue(): Consent {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (raw === "true") return "true";
    if (raw === "false") return "false";
    return undefined;
  } catch {
    return undefined;
  }
}

function storeValue(value: true_or_false_str) {
  localStorage.setItem(CONSENT_KEY, value);
}

export function getPCADataSharingConsent() {
  return getStoredValue();
}

export function putPCADataSharingConsent(userAnswer: any) {
  const remoteValue: Consent = normalize(userAnswer);
  if (remoteValue === undefined) return;
  // conflict resolution
  const localValue = getStoredValue();
  // If there is no local value, store remote value.
  // Otherwise, local value takes priority (even if different from remote).
  if (localValue === undefined) storeValue(remoteValue);
  return;
}

function normalize(userAnswer: string | boolean): Consent {
  if (userAnswer === true || userAnswer === "true") return "true";
  if (userAnswer === false || userAnswer === "false") return "false";
  return undefined;
}
